import Vue from 'vue'
import Router from 'vue-router'
import { PRIVATE_ID } from "@/common/consts.js";
import {getUrlQuery} from '@/utils';
import privateServerConfig from "@/common/privateServerConfig";

Vue.use(Router)

// 解决Iview导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const routerMethods = ['push', 'replace'];
routerMethods.forEach((method) => {
  const originalCall = Router.prototype[method];
  Router.prototype[method] = function(location, onResolve, onReject) {
    if (onResolve || onReject) {
      return originalCall.call(this, location, onResolve, onReject);
    }
    return (originalCall.call(this, location)).catch((err) => err);
  };
});
// 定制化页面路由
let privateRoutes = [];
const mid = getUrlQuery(window.location.href).m_id
if (mid && privateServerConfig[mid]) {
  privateRoutes = privateServerConfig[mid].routes || []
}



const router = new Router({
  mode:process.env.NODE_ENV === 'production'?'history':'hash',
  routes: [{
    path: '/',
    name: 'index',
    meta:{
      noCheckLogin:true
    },
    component: r => require.ensure([], () => r(require('@/pages/home/index')), 'index')
  }, {
    path: '/list/theatre',
    name: 'theatre',
    meta:{
      noCheckLogin:true
    },
    component: r => require.ensure([], () => r(require('@/pages/theatre/theatrelist')), 'theatrelist')
  }, {
    path: '/theatreDetail',
    name: 'theatreDetail',
    meta:{
      noCheckLogin:true
    },
    component: r => require.ensure([], () => r(require('@/pages/theatre/theatreDetail')), 'theatreDetail')
  }, {
    path: '/areaSelect',
    name: 'areaSelect',
    component: r => require.ensure([], () => r(require('@/pages/theatre/areaSelect')), 'areaSelect')
  }, {
    path: '/seatSelect',
    name: 'seatSelect',
    component: r => require.ensure([], () => r(require('@/pages/theatre/seatSelect')), 'seatSelect')
  }, {
    path: '/theatreOrder',
    name: 'theatreOrder',
    component: r => require.ensure([], () => r(require('@/pages/theatre/theatreOrder')), 'theatreOrder')
  }, {
    path: '/theaterPay',
    name: 'theaterPay',
    component: r => require.ensure([], () => r(require('@/pages/theatre/theaterPay')), 'theaterPay')
  }, {
    path: '/list/ticket',
    name: 'ticketlist',
    meta:{
      noCheckLogin:true
    },
    component: r => require.ensure([], () => r(require('@/pages/ticket/ticketlist')), 'ticketlist')
  }, {
    path: '/detail/ticket',
    name: 'ticketDetail',
    meta:{
      noCheckLogin:true
    },
    component: r => require.ensure([], () => r(require('@/pages/ticket/ticketDetail')), 'ticketDetail')
  },
  // {
  //   path: '/order/ticket',
  //   name: 'ticketOrder',
  //   component: r => require.ensure([], () => r(require('@/pages/ticket/ticketOrder')), 'ticketOrder')
  // },
  {
    path: '/list/eatery',
    name: 'eaterylist',
    meta:{
      noCheckLogin:true
    },
    component: r => require.ensure([], () => r(require('@/pages/eatery/eaterylist')), 'eaterylist')
  },
  {
    path: '/detail/eatery',
    name: 'eateryDetail',
    meta:{
      noCheckLogin:true
    },
    component: r => require.ensure([], () => r(require('@/pages/eatery/eateryDetail')), 'eateryDetail')
  },
  {
    path: '/detail/repastCoupon',
    name: 'repastCouponDetail',
    meta:{
      noCheckLogin:true
    },
    component: r => require.ensure([], () => r(require('@/pages/eatery/couponDetail')), 'repastCouponDetail')
  },
  {
    path: '/order/repastCoupon',
    name: 'repastCouponOrder',
    component: r => require.ensure([], () => r(require('@/pages/eatery/couponOrder')), 'repastCouponOrder')
  },
  {
    path: '/eateryPay',
    name: 'eateryPay',
    component: r => require.ensure([], () => r(require('@/pages/eatery/eateryPay')), 'eateryPay')
  }, 
  {
    path: '/order/ticket',
    name: 'ticketOrder',
    component: r => require.ensure([], () => r(require('@/pages/ticket/ticketOrder')), 'ticketOrder')
  },
  {
    path: '/ticketPay',
    name: 'TicketPay',
    component: r => require.ensure([], () => r(require('@/pages/ticket/ticketPay')), 'TicketPay')
  },{
    path: '/list/hotel',
    name: 'hotellist',
    meta:{
      noCheckLogin:true
    },
    component: r => require.ensure([], () => r(require('@/pages/hotel/hotellist')), 'hotellist')
  },{
    path: '/detail/hotel',
    name: 'hotelDetail',
    meta:{
      noCheckLogin:true
    },
    component: r => require.ensure([], () => r(require('@/pages/hotel/hotelDetail')), 'hotelDetail')
  },{
    path: '/order/hotel',
    name: 'hotelOrder',
    component: r => require.ensure([], () => r(require('@/pages/hotel/hotelOrder')), 'hotelOrder')
  },
  {
    path: '/hotelPay',
    name: 'HotelPay',
    component: r => require.ensure([], () => r(require('@/pages/hotel/hotelPay')), 'HotelPay')
  },{
    path: '/list/route',
    name: 'routelist',
    meta:{
      noCheckLogin:true
    },
    component: r => require.ensure([], () => r(require('@/pages/route/routelist')), 'routelist')
  },{
    path: '/detail/route',
    name: 'routeDetail',
    meta:{
      noCheckLogin:true
    },
    component: r => require.ensure([], () => r(require('@/pages/route/routeDetail')), 'routeDetail')
  },{
    path: '/order/route',
    name: 'routeOrder',
    component: r => require.ensure([], () => r(require('@/pages/route/routeOrder')), 'routeOrder')
  },{
    path: '/list/allTickets',
    name: 'allTicketslist',
    meta:{
      noCheckLogin:true
    },
    component: r => require.ensure([], () => r(require('@/pages/allTickets/allTicketslist')), 'allTicketslist')
  },{
    path: '/detail/allTickets',
    name: 'allTicketsDetail',
    meta:{
      noCheckLogin:true
    },
    component: r => require.ensure([], () => r(require('@/pages/allTickets/allTicketsDetail')), 'allTicketsDetail')
  },{
    path: '/routePay',
    name: 'RoutePay',
    component: r => require.ensure([], () => r(require('@/pages/route/routePay')), 'RoutePay')
  },{
    path: '/list/shop',
    name: 'shoplist',
    meta:{
      noCheckLogin:true
    },
    component: r => require.ensure([], () => r(require('@/pages/shop/shoplist')), 'shoplist')
  },{
    path: '/detail/shop',
    name: 'shopDetail',
    meta:{
      noCheckLogin:true
    },
    component: r => require.ensure([], () => r(require('@/pages/shop/shopDetail')), 'shopDetail')
  },{
    path: '/order/shop',
    name: 'shopOrder',
    component: r => require.ensure([], () => r(require('@/pages/shop/shopOrder')), 'shopOrder')
  },
  {
    path: '/shopPay',
    name: 'shopPay',
    component: r => require.ensure([], () => r(require('@/pages/shop/shopPay')), 'shopPay')
  },{
    path: '/payResult',
    name: 'payResult',
    component: r => require.ensure([], () => r(require('@/pages/theatre/payResult')), 'payResult')
  }, {
    path: '/login',
    name: 'login',
    component: r => require.ensure([], () => r(require('@/pages/theatre/login')), 'login')
  }, {
    path: '/register',
    name: 'register',
    component: r => require.ensure([], () => r(require('@/pages/theatre/register')), 'register')
  },
  {
    path: '/detail/news',
    name: 'newsDetail',
    meta:{
      noCheckLogin:true
    },
    component: r => require.ensure([], () => r(require('@/pages/news/newsDetail')), 'newsDetail')
  },
  {
    path: '/newslist',
    name: 'newslist',
    meta:{
      noCheckLogin:true
    },
    component: r => require.ensure([], () => r(require('@/pages/news/newslist')), 'newslist')
  },
  {
    path:'/member',
    name:'member',
    component:r => require.ensure([],() => r(require('@/pages/member/member')),'member'),
    children: [
      {
        path: '/member',
        name: 'user',
        component: r => require.ensure([], () => r(require('@/pages/member/components/user')), 'user')
      },    
      {
        path: '/order/list',
        name: 'orderlist',
        component: r => require.ensure([], () => r(require('@/pages/member/order/orderList')), 'orderList')
      },{
        path: '/order/detail',
        name: 'orderdetail',
        component: r => require.ensure([], () => r(require('@/pages/member/order/orderDetail')), 'orderDetail')
      },  
      {
        path: '/coupons/list',
        name: 'mycoupons',
        component: r => require.ensure([], () => r(require('@/pages/member/coupons/mycoupons')), 'mycoupons')
      },
      {
        path: '/coupons/get',
        name: 'getcoupons',
        component: r => require.ensure([], () => r(require('@/pages/member/coupons/getcoupons')), 'getcoupons')
      },
      {
        path: '/member/links',
        name: 'links',
        component: r => require.ensure([], () => r(require('@/pages/member/components/links')), 'links')
      },
      {
        path: '/invoice/list',
        name: 'invoiceList',
        component: r => require.ensure([], () => r(require('@/pages/invoice/list')), 'invoiceList')
      },
      {
        path: '/invoice/apply',
        name: 'invoiceApply',
        component: r => require.ensure([], () => r(require('@/pages/invoice/apply')), 'invoiceApply')
      }
    ]
  },
  {
    path: '/tourGuide',
    name: 'tourGuide',
    meta:{
      noCheckLogin:true
    },
    beforeEnter(to,from,next){
      if(Number(to.query.m_id)===PRIVATE_ID){
        next()
      }else{
        next('/404')
      }
    },
    component: r => require.ensure([], () => r(require('@/pages/tourGuide')), 'tourGuide')
  },
  ...privateRoutes,
],
  scrollBehavior(to, from, savedPosition) {    
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop;
      }
      return {
        x: 0,
        y: to.meta.savedPosition || 0
      }
    }
  }
})

router.beforeEach((to, from, next) => {
  // store.dispatch('updateLoadingStatus', {isLoading: true})
  if (to.matched && to.matched.length) {
    if (to.path == '/payResult') {
      next()
    } else {
      if (to.fullPath == '/404') {
        next()
      } else {
        if (to.query.m_id) {
          localStorage.setItem('m_id', to.query.m_id)
          localStorage.setItem('id', to.query.id)
          next()
        } else {
          const mid = from.query.m_id || localStorage.getItem('m_id')
          if (mid) {
            to.query.m_id = mid
            to.query.id = from.query.id
            next({
              ...to,
              replace: true,
            })
          } else {
            next('/404')
          }
        }
      }
      
    }

  } else {
    if (to.fullPath == '/404') {
      next()
    } else {
      next('/404')
    }
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js